export function audioDurationOf(file: Blob): Promise<number | undefined> {
  return new Promise((resolve) => {
    const objectUrl = URL.createObjectURL(file);
    const audio = new Audio();
    audio.preload = "metadata";
    audio.onloadedmetadata = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(Number.isFinite(audio.duration) ? Math.max(1, Math.round(audio.duration)) : undefined);
    };
    audio.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(undefined);
    };
    audio.src = objectUrl;
  });
}

export function formatClipSeconds(seconds: number): string {
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
}
